export default __webpack_public_path__ + "static/media/loading.eb364e6f.gif";